<template>
  <div class="address-list">
    <div class="list-container" v-if="items.length>0">
      <AddressListItem
        @select="applyDeliveryAddress(address.address); applyDeliveryAddress(address.address); resetList()"
        :address="address"
        class="address-list-item"
        v-for="(address, index) in items"
        :key="index"
      ></AddressListItem>
    </div>
    <button @click="lookupPostcode(postcode)" type="button" class="lookup-button">{{ label }}</button>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import AddressListItem from "@/components/cart/AddressListItem";

export default {
  props: ["value", "postcode", "label"],
  components: {
    AddressListItem
  },
  methods: {
    ...mapActions("address", ["lookupPostcode", "resetList"]),
    ...mapActions("basket", ["applyDeliveryAddress"])
  },
  computed: {
    ...mapState({
      items: state => state.address.items
    })
  }
};
</script>